import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { findDOMNode } from 'react-dom';
import ScaleLine from 'ol/control/ScaleLine';
import { getMap } from '../mapStore';
export class MapScaleLinePreview extends React.PureComponent {
    control;
    componentDidMount() {
        this.control = new ScaleLine({
            // eslint-disable-next-line react/no-find-dom-node
            target: findDOMNode(this),
            className: 'rpx-scaleLine',
            minWidth: 120,
            bar: true,
        });
        const map = getMap(this.props.mapIdent);
        map && map.addControl(this.control);
    }
    componentWillUnmount() {
        const map = getMap(this.props.mapIdent);
        map && map.removeControl(this.control);
    }
    render() {
        return _jsx("div", {});
    }
}
//# sourceMappingURL=preview.js.map